export default function Logo({
  className,
}: { className?: string } & React.ComponentProps<"svg">) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="165"
      height="63"
      viewBox="0 0 165 63"
      fill="currentColor"
      className={className}
    >
      <path
        d="M41.5045 15.3518C35.4633 15.3518 30.8045 17.3612 27.6943 21.2905V16.5677H18.543V60.8524H27.7711V37.8909C27.7711 28.6372 31.9564 23.748 39.8662 23.748C46.7137 23.748 50.3358 27.5109 50.3358 34.6272V60.8396H59.564V33.3984C59.564 22.0841 52.806 15.3262 41.4917 15.3262L41.5045 15.3518Z"
        fill="currentColor"
      />
      <path
        d="M78.0738 16.5801H68.8457V60.8648H78.0738V16.5801Z"
        fill="currentColor"
      />
      <path
        d="M9.80234 16.5801H0.574219V60.8648H9.80234V16.5801Z"
        fill="currentColor"
      />
      <path
        d="M10.3928 0.722656H0V10.4371H10.3928V0.722656Z"
        fill="currentColor"
      />
      <path
        d="M78.6624 0.722656H68.2695V10.4371H78.6624V0.722656Z"
        fill="currentColor"
      />
      <path
        d="M102.456 5.16406H93.2277V16.5808H83.4492V24.9898H93.2277V47.6825C93.2277 56.4243 97.6562 60.8528 106.398 60.8528H114.679V52.4438H102.725C102.584 52.4438 102.533 52.431 102.533 52.431L102.456 52.367C102.456 52.367 102.443 52.3286 102.443 52.175V24.9898H114.666V16.5808H102.443V5.16406H102.456Z"
        fill="currentColor"
      />
      <path
        d="M141.187 15.3516C128.286 15.3516 117.816 25.8084 117.816 38.7226C117.816 51.6369 128.273 62.0937 141.187 62.0937C154.102 62.0937 164.559 51.6369 164.559 38.7226C164.559 25.8084 154.102 15.3516 141.187 15.3516ZM154.319 51.8417H128.068V25.5908H154.319V51.8417Z"
        fill="currentColor"
      />
    </svg>
  );
}
